import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgObjectDetection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.855 3.179 C 7.934 3.427,7.226 4.243,7.102 5.201 C 7.036 5.706,7.036 22.794,7.102 23.299 C 7.229 24.278,7.932 25.077,8.885 25.325 C 9.314 25.437,19.186 25.437,19.615 25.325 C 20.568 25.077,21.271 24.278,21.398 23.299 C 21.464 22.794,21.464 5.706,21.398 5.201 C 21.273 4.231,20.562 3.421,19.623 3.177 C 19.194 3.065,9.272 3.067,8.855 3.179 M19.401 4.793 C 19.497 4.843,19.626 4.959,19.688 5.050 C 19.787 5.196,19.800 5.277,19.800 5.757 L 19.800 6.300 14.250 6.300 L 8.700 6.300 8.700 5.757 C 8.700 5.277,8.713 5.195,8.813 5.045 C 9.059 4.677,8.700 4.700,14.251 4.700 C 18.998 4.700,19.235 4.704,19.401 4.793 M19.800 14.275 L 19.800 20.650 14.250 20.650 L 8.700 20.650 8.700 14.275 L 8.700 7.900 14.250 7.900 L 19.800 7.900 19.800 14.275 M19.800 22.768 C 19.800 23.222,19.786 23.306,19.687 23.455 C 19.441 23.823,19.800 23.800,14.250 23.800 C 8.700 23.800,9.059 23.823,8.813 23.455 C 8.714 23.306,8.700 23.222,8.700 22.768 L 8.700 22.250 14.250 22.250 L 19.800 22.250 19.800 22.768 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgObjectDetection;
